import { useState } from "react";
import MainLayout from "layouts/Main";
import { settingsTabs } from "views/Dashboard/Settings/tabs";
import { Box } from "@mui/material";
import ForecaTable from "./ForecaTable";

const ForecaSettings = () => {
  const [snackbar, setSnackbar] = useState(null);

  const snackbarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbar(null);
  };

  return (
    <MainLayout
      tabs={settingsTabs}
      snackbar={{
        open: !!snackbar,
        handleClose: snackbarClose,
        type: snackbar?.type,
        message: snackbar?.message,
      }}
    >
      <Box display="flex" justifyContent="space-between" sx={{ mt: 4 }}>
        <Box sx={{ flex: 1, mr: 8 }}>
          <ForecaTable setSnackbar={snackbar} />
        </Box>
      </Box>
    </MainLayout>
  );
};
export default ForecaSettings;
